import { __awaiter, __rest } from '../../node_modules/tslib/tslib.es6.js';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { styled, Switch, Slide, Grid, useMediaQuery, Dialog, TextField } from '@mui/material';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import React__default, { useState, useEffect, useMemo } from 'react';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import { searchProductsRest } from '../../api/utils.js';
import '../../api/cache/appConfigQueryOptions.js';
import brandclub_colors from '../../colors/brandclubColors.js';
import { AppCheckbox } from '../../Components/AppCheckbox/index.js';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/CheckMarkIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import { SearchIcon } from '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';
import { Button } from '../../Components/Button/Button.js';
import '../../Components/Button/CustomDtcBagButton.js';
import { brandclubStyles } from '../../styles/index.js';
import { FilterParam, getFilterParamKeyFromValue } from '../../types/filters.js';
import { TABLET_SCREEN_SIZE } from '../../utils/constants/Constants.js';
import { searchParamsToSearchFilters } from '../SearchResults/searchResultsUtils.js';

const SHOW_MORE_INITIAL_LIMIT = 6;
const SHOW_MORE_LIMIT = 100;
const BrandclubFilterSwitch = styled((props) => (React__default.createElement(Switch, Object.assign({ checkedIcon: React__default.createElement("div", { style: {
            width: 14,
            height: 14,
            borderRadius: 100,
            backgroundColor: '#fff',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
        } },
        React__default.createElement(CheckRoundedIcon, { sx: (theme) => ({
                color: theme.vars.palette.text.primary,
                width: 12,
                height: 12,
            }) })), focusVisibleClassName: ".Mui-focusVisible", disableRipple: true }, props))))(({ theme }) => ({
    width: 30,
    height: 20,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 3,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(10px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.vars.palette.primary.main,
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: 'grey',
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 14,
        height: 14,
        boxShadow: 'none',
    },
    '& .MuiSwitch-track': {
        borderRadius: 100,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 300,
        }),
    },
}));
const Transition = React__default.forwardRef(function Transition(props, ref) {
    return React__default.createElement(Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const FilterHeader = styled(Grid)(({ theme }) => ({
    fontFamily: 'Poppins',
    color: theme.vars.palette.text.primary,
    padding: '21px 30px',
    display: 'grid',
    gridTemplateColumns: '50px auto 50px',
    width: 690,
    borderBottom: `1px solid ${brandclub_colors.blueWhite}`,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        width: '100%',
        '.center': { fontSize: 16 },
        '.right': {
            fontSize: 14,
        },
    },
    '.left': {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    '.center': {
        fontSize: 18,
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    '.right': {
        fontSize: 16,
        fontWeight: 500,
        color: theme.vars.palette.text.primary,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        cursor: 'pointer',
    },
}));
const FilterFooter = styled(Grid)(({ theme }) => ({
    fontFamily: 'Poppins',
    color: theme.vars.palette.text.primary,
    padding: '20px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: `1px solid ${brandclub_colors.blueWhite}`,
    '.apply_button': {
        fontFamily: 'Poppins',
        padding: '12px 100px',
        outline: 'none',
        border: 'none',
        background: theme.vars.palette.primary.main,
        color: theme.vars.palette.primary.contrastText,
        borderRadius: 999,
        fontSize: 16,
        fontWeight: 500,
    },
}));
const FilterContentContainer = styled(Grid)(({ theme }) => (Object.assign(Object.assign({ color: theme.vars.palette.text.primary, fontSize: 16, fontWeight: 500, display: 'flex', flexDirection: 'column', padding: '0 30px', width: 690, overflowY: 'scroll' }, brandclubStyles.customScrollbar), { [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        width: '100%',
        fontSize: 14,
    }, '.mobile_search_bar': {
        display: 'none',
        [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
            display: 'block',
        },
    }, '.row': {
        borderBottom: `1px solid ${brandclub_colors.blueWhite}`,
        padding: '30px 0px',
        '&:las-child': {
            borderBottom: `none`,
        },
        '.row_title': {
            fontSize: 20,
            fontWeight: 600,
            marginBottom: 13,
            [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
                fontSize: 14,
            },
        },
        '.row_options': {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
                gridTemplateColumns: '1fr',
            },
            gap: '8px',
            '.show_more': {
                textDecoration: 'underline',
                cursor: 'pointer',
            },
            '.option': {
                display: 'flex',
                alignItems: 'flex-start',
                '.option_label': {
                    wordBreak: 'break-word',
                    paddingTop: '9px',
                },
            },
            '.option_reward': {
                display: 'flex',
                flexWrap: 'nowrap',
                [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
                    gridColumnStart: 1,
                    gridRowStart: 1,
                },
                '&.right': {
                    gridColumnStart: 1,
                    gridRowStart: 1,
                    gridRowEnd: 3,
                    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
                        gridColumnStart: 1,
                        gridRowStart: 1,
                    },
                },
                '.toggle_text': {
                    marginLeft: 11,
                    maxWidth: 200,
                },
            },
        },
    } })));
const FilterDialogContainer = styled('div')({
    height: '100%',
    display: 'grid',
    gridTemplateRows: '70px 1fr 83px',
});
const getStaticFilters = () => ({
    RetailPrice: [
        { name: '0to25', displayName: '$0 - $25', enable: false },
        { name: '25to50', displayName: '$25 - $50', enable: false },
        { name: '50to100', displayName: '$50 - $100', enable: false },
        { name: 'over100', displayName: 'Over $100', enable: false },
    ],
    CampaignTypes: [
        {
            name: 'purchaseRewardCampaign',
            displayName: 'Purchase rewards',
            enable: false,
        },
        {
            name: 'affiliateLinkCampaign',
            displayName: 'Affiliate rewards',
            enable: false,
        },
    ],
});
const getDynamicFilters = (facetsResult) => {
    const res = {};
    const categoryFacets = _get(facetsResult, ['facets', 'categoryId'], []);
    const subCategoryFacets = _get(facetsResult, ['facets', 'subCategoryId'], []);
    const retailerFacets = _get(facetsResult, ['facets', 'retailerId'], []);
    const brandFacets = _get(facetsResult, ['facets', 'brandId'], []);
    if (!_isEmpty(categoryFacets)) {
        res.CategoryIds = categoryFacets.map((category) => ({
            name: category.categoryId,
            displayName: category.name,
            enable: false,
        }));
    }
    if (!_isEmpty(subCategoryFacets)) {
        res.SubcategoryIds = subCategoryFacets.map((subCategory) => ({
            name: subCategory.subCategoryId,
            displayName: subCategory.name,
            enable: false,
        }));
    }
    if (!_isEmpty(retailerFacets)) {
        res.RetailerIds = retailerFacets.map((retailer) => ({
            name: retailer.retailerId,
            displayName: retailer.name,
            enable: false,
        }));
    }
    if (!_isEmpty(brandFacets)) {
        res.BrandIds = brandFacets.map((brand) => ({
            name: brand.brandId,
            displayName: brand.name,
            enable: false,
        }));
    }
    return res;
};
const convertFilterStateToSearchParams = (filterState) => {
    let searchRoute = '';
    Object.entries(filterState).forEach(([filterName, filterValues]) => {
        filterValues === null || filterValues === void 0 ? void 0 : filterValues.forEach((option) => {
            if (option.enable) {
                searchRoute += `&${FilterParam[filterName]}=${option.name}`;
            }
        });
    });
    return searchRoute;
};
const convertSearchParamToFilterState = (searchParams, filterState) => {
    const params = {};
    searchParams.forEach((value, key) => {
        var _a;
        const decodedKey = decodeURIComponent(key);
        const decodedValue = decodeURIComponent(value);
        const filterKey = getFilterParamKeyFromValue(decodedKey);
        if (!filterKey)
            return;
        if (filterKey !== 'VersionId' && filterKey !== 'SiteId') {
            params[filterKey] = params[filterKey] || [];
            (_a = params[filterKey]) === null || _a === void 0 ? void 0 : _a.push(decodedValue);
        }
        else {
            params[filterKey] = decodedValue;
        }
    });
    const newFilterState = _cloneDeep(filterState);
    Object.entries(newFilterState).forEach(([filterName, filterValues]) => {
        filterValues === null || filterValues === void 0 ? void 0 : filterValues.forEach((state) => {
            var _a;
            if ((_a = params[filterName]) === null || _a === void 0 ? void 0 : _a.includes(`${state.name}`)) {
                state.enable = true;
            }
        });
    });
    return newFilterState;
};
const SelectOption = ({ checked = false, displayName = '', onChange }) => (React__default.createElement("div", { className: "option" },
    React__default.createElement(AppCheckbox, { checkboxProps: {
            checked,
            sx: (theme) => ({
                padding: '0px 19px 0px 0px',
                marginLeft: '-2px',
                '&.Mui-checked': {
                    color: theme.vars.palette.text.primary,
                },
            }),
            onChange,
        }, label: "", hideLabel: true }),
    React__default.createElement("div", { className: "option_label" }, displayName)));
const FilterRow = (_a) => {
    var { title, options, onChange } = _a, props = __rest(_a, ["title", "options", "onChange"]);
    return (React__default.createElement("div", { className: "row" },
        React__default.createElement("div", { className: "row_title" }, title),
        React__default.createElement("div", { className: "row_options" },
            !props.hideOptions &&
                options.map((option) => {
                    return (React__default.createElement(SelectOption, { onChange: (e, checked) => {
                            onChange(option.name, checked);
                        }, key: option.name, checked: option === null || option === void 0 ? void 0 : option.enable, displayName: option === null || option === void 0 ? void 0 : option.displayName }));
                }),
            props.children)));
};
const ShowMore = ({ onClick, className }) => (React__default.createElement(Button, { onClick: onClick, className: [className, 'show_more'].filter(Boolean).join(' '), variant: "text", sx: {
        width: 'fit-content',
        fontWeight: 500,
    } }, "Show more"));
const FilterContent = ({ searchInput, applyFilter, setSearchInput, filterState, toggleFilterState }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const [categoryIdsLimit, setCategoryIdsLimit] = useState(SHOW_MORE_INITIAL_LIMIT);
    const [subcategoryIdsLimit, setSubcategoryIdsLimit] = useState(SHOW_MORE_INITIAL_LIMIT);
    const [brandIdsLimit, setBrandIdsLimit] = useState(SHOW_MORE_INITIAL_LIMIT);
    const brandIds = useMemo(() => {
        var _a;
        return (_a = filterState === null || filterState === void 0 ? void 0 : filterState.BrandIds) === null || _a === void 0 ? void 0 : _a.slice(0, brandIdsLimit);
    }, [filterState === null || filterState === void 0 ? void 0 : filterState.BrandIds, brandIdsLimit]);
    const categoryIds = useMemo(() => {
        var _a;
        return (_a = filterState === null || filterState === void 0 ? void 0 : filterState.CategoryIds) === null || _a === void 0 ? void 0 : _a.slice(0, categoryIdsLimit);
    }, [filterState === null || filterState === void 0 ? void 0 : filterState.CategoryIds, categoryIdsLimit]);
    const subcategoryIds = useMemo(() => {
        var _a;
        return (_a = filterState === null || filterState === void 0 ? void 0 : filterState.SubcategoryIds) === null || _a === void 0 ? void 0 : _a.slice(0, subcategoryIdsLimit);
    }, [filterState === null || filterState === void 0 ? void 0 : filterState.SubcategoryIds, subcategoryIdsLimit]);
    const categoryShowMore = categoryIdsLimit < ((_b = (_a = filterState === null || filterState === void 0 ? void 0 : filterState.CategoryIds) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
    const subCategoryShowMore = subcategoryIdsLimit < ((_d = (_c = filterState === null || filterState === void 0 ? void 0 : filterState.SubcategoryIds) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0);
    const brandShowMore = brandIdsLimit < ((_f = (_e = filterState === null || filterState === void 0 ? void 0 : filterState.BrandIds) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0);
    const anyRewardChecked = !!((_g = filterState === null || filterState === void 0 ? void 0 : filterState.CampaignTypes) === null || _g === void 0 ? void 0 : _g.find((type) => type === null || type === void 0 ? void 0 : type.enable));
    return (React__default.createElement(FilterContentContainer, null,
        React__default.createElement("div", { className: "row mobile_search_bar" },
            React__default.createElement(TextField, { variant: "standard", placeholder: "Search products", value: searchInput, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        applyFilter();
                    }
                }, onChange: (event) => setSearchInput(event.target.value), inputProps: { maxLength: 200 }, InputProps: {
                    disableUnderline: true,
                    startAdornment: React__default.createElement(SearchIcon, { color: "primary", sx: { marginRight: 1.25, fontSize: 13 } }),
                }, sx: (theme) => ({
                    borderRadius: 17,
                    height: 38,
                    width: '100%',
                    flex: 1,
                    backgroundColor: brandclub_colors.blueWhite,
                    '& div.MuiInput-root': {
                        padding: '0 4px 0 14px',
                        display: 'flex',
                        alignItems: 'center',
                        height: 38,
                        '& input': {
                            padding: 0,
                            fontSize: 12,
                            fontWeight: 500,
                            fontFamily: 'Poppins',
                            color: theme.vars.palette.text.primary,
                        },
                    },
                }) })),
        (filterState === null || filterState === void 0 ? void 0 : filterState.CampaignTypes) && (React__default.createElement(FilterRow, { title: "Rewards", options: filterState.CampaignTypes, onChange: (name, enabled) => toggleFilterState('CampaignTypes', name, enabled), hideOptions: !anyRewardChecked },
            React__default.createElement("div", { className: `option_reward ${anyRewardChecked ? 'right' : ''}` },
                React__default.createElement(BrandclubFilterSwitch, { sx: { margin: '2px 0px' }, checked: anyRewardChecked, onChange: (_, checked) => toggleFilterState('CampaignTypes', null, checked) }),
                React__default.createElement("div", { className: "toggle_text" }, "Only show products with reward offers")))),
        (filterState === null || filterState === void 0 ? void 0 : filterState.RetailPrice) && (React__default.createElement(FilterRow, { title: "Price", options: filterState.RetailPrice, onChange: (name, enabled) => toggleFilterState('RetailPrice', name, enabled) })),
        (filterState === null || filterState === void 0 ? void 0 : filterState.RetailerIds) && (React__default.createElement(FilterRow, { title: "Stores", options: filterState.RetailerIds, onChange: (name, enabled) => toggleFilterState('RetailerIds', name, enabled) })),
        brandIds && (React__default.createElement(FilterRow, { title: "Brands", options: brandIds, onChange: (name, enabled) => toggleFilterState('BrandIds', name, enabled) }, brandShowMore && (React__default.createElement(ShowMore, { onClick: () => {
                setBrandIdsLimit((prevLimit) => prevLimit + SHOW_MORE_LIMIT);
            } })))),
        categoryIds && (React__default.createElement(FilterRow, { title: "Categories", options: categoryIds, onChange: (name, enabled) => toggleFilterState('CategoryIds', name, enabled) }, categoryShowMore && (React__default.createElement(ShowMore, { onClick: () => {
                setCategoryIdsLimit((prevLimit) => prevLimit + SHOW_MORE_LIMIT);
            } })))),
        subcategoryIds && (React__default.createElement(FilterRow, { title: "Subcategories", options: subcategoryIds, onChange: (name, enabled) => toggleFilterState('SubcategoryIds', name, enabled) }, subCategoryShowMore && (React__default.createElement(ShowMore, { onClick: () => {
                setSubcategoryIdsLimit((prevLimit) => prevLimit + SHOW_MORE_LIMIT);
            } }))))));
};
const FilterDialog = ({ onCloseSearchDropdown, searchInput, setSearchInput, brandId, navigate, open, onClose, persistentQueryParams, searchParams, pageContext, axios, routePrefix, }) => {
    const [originFilterState, setOriginFilterState] = useState({});
    const [filterState, setFilterState] = useState({});
    const desktopView = useMediaQuery(`(min-width:${TABLET_SCREEN_SIZE}px)`);
    useEffect(() => {
        const generateCurrentFilters = () => __awaiter(void 0, void 0, void 0, function* () {
            const searchRequestBody = searchParamsToSearchFilters(searchParams, pageContext, brandId);
            const facetsResult = yield searchProductsRest(axios, searchRequestBody, { start: 0, size: 0 }, {
                computeFacets: true,
                facetFieldNames: ['categoryId', 'retailerId', 'subCategoryId', 'brandId'],
            }, undefined);
            const originFilterState = Object.assign(Object.assign({}, getStaticFilters()), getDynamicFilters(facetsResult));
            const newFilterState = convertSearchParamToFilterState(searchParams, originFilterState);
            setOriginFilterState(originFilterState);
            setFilterState(newFilterState);
        });
        generateCurrentFilters();
    }, [searchParams, brandId]);
    const toggleFilterState = (filterName, filterValue, enabled) => {
        var _a;
        const filterStateClone = _cloneDeep(filterState);
        (_a = filterStateClone[filterName]) === null || _a === void 0 ? void 0 : _a.forEach((option) => {
            if (filterValue === null || option.name === filterValue) {
                option.enable = enabled;
            }
        });
        setFilterState(filterStateClone);
    };
    const applyFilter = () => {
        let searchUrl = routePrefix + `/search?`;
        const searchParams = convertFilterStateToSearchParams(filterState);
        if (searchInput) {
            const encodedSearchInput = encodeURIComponent(searchInput.trim());
            searchUrl += `${FilterParam.TitleInclude}=${encodedSearchInput}`;
        }
        searchUrl += searchParams;
        if (persistentQueryParams) {
            searchUrl += `&${persistentQueryParams}`;
        }
        onCloseSearchDropdown === null || onCloseSearchDropdown === void 0 ? void 0 : onCloseSearchDropdown();
        navigate(searchUrl);
        setFilterState({});
        onClose();
    };
    return (React__default.createElement(Dialog, { fullScreen: !desktopView, TransitionComponent: desktopView ? undefined : Transition, onClose: onClose, PaperProps: {
            style: {
                height: desktopView ? 800 : '100%',
                maxWidth: 'unset',
                boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
            },
        }, style: { zIndex: 1500 }, open: open },
        React__default.createElement(FilterDialogContainer, null,
            React__default.createElement(FilterHeader, null,
                React__default.createElement("div", { className: "left" },
                    React__default.createElement(CloseRoundedIcon, { color: "primary", onClick: onClose, sx: { cursor: 'pointer' } })),
                React__default.createElement("div", { className: "center" }, "Filter"),
                React__default.createElement("div", { className: "right", role: "button", style: { cursor: 'pointer' }, onClick: () => {
                        setFilterState(originFilterState);
                        setSearchInput('');
                    } }, "Clear")),
            React__default.createElement(FilterContent, { searchInput: searchInput, setSearchInput: setSearchInput, applyFilter: applyFilter, filterState: filterState, toggleFilterState: toggleFilterState }),
            React__default.createElement(FilterFooter, null,
                React__default.createElement("button", { className: "apply_button", onClick: applyFilter }, "Apply")))));
};

export { FilterDialog };
//# sourceMappingURL=FilterDialog.js.map
